export default function (state, action) {
  switch (action.type) {
    case 'SET_MEDIAS':
      return [...action.data];
    default:
      return state;
  }
}
